import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core'
import { ToastrService } from 'ngx-toastr';
import { AffiliationsService } from './recruitsaffiliations-view.service';
import { HttpClient ,HttpEventType} from '@angular/common/http';
@Component({
    selector: 'app-form-recruitsaffiliations',
    templateUrl: './recruitsaffiliations-view.component.html',
    styleUrls: ['./recruitsaffiliations-view.component.scss'] 
  })
  export class AffiliationsComponent implements OnInit{
    @ViewChild('dw11') dw_11;
    Document: File = null;
    @Input() Documentvalue:string;
    public response: {'dbPath': ''};
    @Output() eventSave = new EventEmitter();
    @Output() eventClose = new EventEmitter();
    @Input() recruit_id:number;
    eventtab = {'activeId':'tab-10',
                  'nextId':'tab-11'}
    constructor(public service:AffiliationsService, private toastr: ToastrService
      ,private http: HttpClient){   
      }  
      ngOnInit(){
      this.onResetForm();
    }
    onResetForm(){
      this.response = {
        'dbPath':''
    };
        this.service.formData11 = {
          id: 0,
          recruitId: this.recruit_id,
          hospital: '',
          address:'',
          refNo: '',
          documents:'' 
        };
  
      }
      async onSaveForm()
      {
        if(this.Documentvalue==null || this.Documentvalue=='')
        {
          await this.onFileUpload();
          this.service.formData11.documents = this.response.dbPath;
        }
              this.service.onPostRecruitsAffiliationsForm().subscribe(success =>{
                  if(success) {
                      this.toastr.success('Data saved successfully!!','Hospital Affiliations/Privileges');
                      this.onReset();
                      this.eventSave.emit(this.eventtab);
                      this.eventClose.emit('false');
                  }
                  else
                  {
                      this.toastr.error('Error while updating Data!!', 'Hospital Affiliations/Privileges');
                  }
              })
      }  
      public onReset()
  {
    this.response = {
      'dbPath':''
  };
      this.dw_11.reset({
        id: 0,
        recruitId: this.recruit_id,
        hospital: '',
        address:'',
        refNo: '',
        documents:''             
      });
  }   
      onCancelForm(){
        this.eventClose.emit('false'); 
      }  
      onFileSelected(event){
    
        if(event.target.files[0]!=null)
           
            
                this.Document = event.target.files[0];
                this.service.formData11.documents = event.target.files[0];
           
        }
      onFileUpload()
      {
          if (this.Document == null)
          {
              return this.response;
          }
          let fileToUpload = this.Document;
             const formData = new FormData();
            formData.append('Document', fileToUpload, fileToUpload.name);
              return this.http.post(`api/upload?foldername=${'Recruits'}`, formData, {observe: 'events'})
            .toPromise().then(event => {
                if (event.type === HttpEventType.Response) {
                this.uploadFinished(event.body);
                }
            });
          
      }
      public uploadFinished = (event) => {
        this.response = event;
    }
    DeleteFile()
    {
       
        if (confirm('Are you sure to delete File?'))
        {
            this.service.DeleteFile(this.service.formData11.id).subscribe(success =>{
                if(success) {
                    
                    this.toastr.info('File is Deleted','Document')
                    this.Documentvalue=null;
                  
                }
                else
                {
                    this.toastr.error('Error while Updating Data!!', 'Document');
                }
            })
        }
    }  
  }